import {
    Typography,
    Link
} from '@mui/material';

import { red } from "@mui/material/colors";

import { productInjectionFields } from "../../../../hooks/model/useProduct"
import { CommonIcons, icons } from "../../../../../../components/common/CommonIcons";

// default
export const getColumnsDefault = ({ t, getRoute }) => {

    return [
        // {
        //     field: 'id',
        //     headerName: 'PId',
        //     // headerClassName: 'my-super-theme--naming-group',
        //     width: 200
        // },
        {
            field: productInjectionFields.registerLocationDisplay.retrieveKey,
            headerName: t("location"),
            headerAlign: 'center',
            align: 'center',
            // headerClassName: 'my-super-theme--naming-group',
            width: 50,
            renderCell: (params) => {
                // console.log('params', params)
                return `${params?.value ? params.value.toUpperCase() : '-'}`
            }
        },
        {
            field: productInjectionFields.loadStatus.retrieveKey,
            headerName: `${t('status')}`,
            // headerClassName: 'my-super-theme--naming-group',
            width: 80,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value ? params.value : '-'

                return `${t(value)}`
            }
        },
        {
            field: productInjectionFields.sourceProductRemId.retrieveKey,
            headerName: `SYNC`,
            // headerClassName: 'my-super-theme--naming-group',
            headerAlign: 'center',
            align: 'center',
            width: 70,
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value

                if (value) {
                    return <CommonIcons name={icons.tick} sx={{ color: 'green' }} />
                }

                return <CommonIcons name={icons.cross} sx={{ color: 'red' }} />
            }
        },

        {
            field: productInjectionFields.customerMarking.retrieveKey,
            headerName: t('marking'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150
        },

        {
            field: productInjectionFields.barcode.retrieveKey,
            headerName: t('barcode'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150,
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value

                return (
                    <Typography
                        sx={{
                            color: red[500],
                            fontSize: 11
                        }}
                    >
                        {value}
                    </Typography>
                )
            }
        },
        {
            field: productInjectionFields.courierTrackingNo.retrieveKey,
            headerName: t('courierNo'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150,
            renderCell: (params) => {
                // console.log('params', params)
                return (
                    <Link
                        href={
                            getRoute(`product/item/update/${params?.row?.id}`)
                        }
                        target="_blank"
                    >
                        {params.value}
                    </Link>
                )
            }
        },
        {
            field: productInjectionFields.supplierName.retrieveKey,
            headerName: t('supplier'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 170,
            valueGetter: ({ value, row }) => {
                return `${value} (${row[productInjectionFields.supplierContact.retrieveKey]})`
            }
        },
        {
            field: productInjectionFields.companyPurchaseNumber.retrieveKey,
            headerName: t('purchaseNo'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 130,
            valueGetter: ({ value, row }) => {
                return `${row[productInjectionFields.companyPurchaseNumber.retrieveKey]} / ${row[productInjectionFields.supplierPurchaseNumber.retrieveKey]}`
            }
        },
        {
            field: productInjectionFields.remark.retrieveKey,
            headerName: t('remark'),
            width: 130,
            valueGetter: ({ value, row }) => {
                return `${value} (${row[productInjectionFields.remark.retrieveKey]})`
            }
        },
        {
            field: `totalCbm`,
            headerName: t('cbm'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 90,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalCbm = items.reduce((total, item) => {
                //     let cbm = parseFloat(item?.cbm).toFixed(4)
                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0
                //     if (Number.isNaN(cbm) || cbm === "NaN") cbm = 0

                //     // console.log('packQty', typeof packQty, cbm)

                //     total += parseFloat(cbm) * parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalCbm)) totalCbm = 0

                // console.log('totalCbm', totalCbm)

                return value
            }
        },
        {
            field: `totalPackQty`,
            headerName: t('packQty'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 90,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },

        {
            field: `${productInjectionFields.signedByUserDisplay.retrieveKey}`,
            headerName: t('signedBy'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {

                return value
            }
        },

        {
            field: `totalValues`,
            headerName: t('values'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },

        {
            field: `totalWeight`,
            headerName: t('weight'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },



        {
            field: `ax_createdatetime`,
            headerName: t('createDateTime'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 200,
            valueGetter: ({ value, row }) => {
                return `${value}`
            }
        },

        {
            field: `${productInjectionFields.checkinDateTime.retrieveKey}`,
            headerName: t('checkedInAt'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 200,
            valueGetter: ({ value, row }) => {
                return `${value}`
            }
        },
    ];
}

// for GZ
export const getColumnsGZ = ({ t, getRoute }) => {

    return [
        {
            field: productInjectionFields.registerLocationDisplay.retrieveKey,
            headerName: t("location"),
            headerAlign: 'center',
            align: 'center',
            // headerClassName: 'my-super-theme--naming-group',
            width: 50,
            renderCell: (params) => {
                // console.log('params', params)
                return `${params?.value ? params.value.toUpperCase() : '-'}`
            }
        },
        {
            field: productInjectionFields.loadStatus.retrieveKey,
            headerName: `${t('status')}`,
            // headerClassName: 'my-super-theme--naming-group',
            width: 80,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value ? params.value : '-'

                return `${t(value)}`
            }
        },
        {
            field: productInjectionFields.sourceProductRemId.retrieveKey,
            headerName: `SYNC`,
            // headerClassName: 'my-super-theme--naming-group',
            headerAlign: 'center',
            align: 'center',
            width: 70,
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value

                if (value) {
                    return <CommonIcons name={icons.tick} sx={{ color: 'green' }} />
                }

                return <CommonIcons name={icons.cross} sx={{ color: 'red' }} />
            }
        },
        {
            field: productInjectionFields.customerMarking.retrieveKey,
            headerName: t('marking'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150
        },
        {
            field: `totalCbm`,
            headerName: t('cbm'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 90,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalCbm = items.reduce((total, item) => {
                //     let cbm = parseFloat(item?.cbm).toFixed(4)
                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0
                //     if (Number.isNaN(cbm) || cbm === "NaN") cbm = 0

                //     // console.log('packQty', typeof packQty, cbm)

                //     total += parseFloat(cbm) * parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalCbm)) totalCbm = 0

                // console.log('totalCbm', totalCbm)

                return value
            }
        },
        {
            field: `totalPackQty`,
            headerName: t('packQty'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 90,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },
        {
            field: `${productInjectionFields.signedByUserDisplay.retrieveKey}`,
            headerName: t('signedBy'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {
                return value
            }
        },
        {
            field: `${productInjectionFields.checkinDateTime.retrieveKey}`,
            headerName: t('checkedInAt'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 200,
            valueGetter: ({ value, row }) => {
                return `${value}`
            }
        },
        {
            field: productInjectionFields.courierTrackingNo.retrieveKey,
            headerName: t('courierNo'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150,
            renderCell: (params) => {
                // console.log('params', params)
                return (
                    <Link
                        href={
                            getRoute(`product/item/update/${params?.row?.id}`)
                        }
                        target="_blank"
                    >
                        {params.value}
                    </Link>
                )
            }
        },
        {
            field: productInjectionFields.supplierName.retrieveKey,
            headerName: t('supplier'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 170,
            valueGetter: ({ value, row }) => {
                return `${value} (${row[productInjectionFields.supplierContact.retrieveKey]})`
            }
        },
        {
            field: productInjectionFields.remark.retrieveKey,
            headerName: t('remark'),
            width: 130,
            valueGetter: ({ value, row }) => {
                return `${value} (${row[productInjectionFields.remark.retrieveKey]})`
            }
        },
        {
            field: productInjectionFields.barcode.retrieveKey,
            headerName: t('barcode'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 150,
            renderCell: (params) => {
                // console.log('params', params)
                let value = params?.value

                return (
                    <Typography
                        sx={{
                            color: red[500],
                            fontSize: 11
                        }}
                    >
                        {value}
                    </Typography>
                )
            }
        },
        {
            field: productInjectionFields.companyPurchaseNumber.retrieveKey,
            headerName: t('purchaseNo'),
            // headerClassName: 'my-super-theme--naming-group',
            width: 130,
            valueGetter: ({ value, row }) => {
                return `${row[productInjectionFields.companyPurchaseNumber.retrieveKey]} / ${row[productInjectionFields.supplierPurchaseNumber.retrieveKey]}`
            }
        },
        {
            field: `totalValues`,
            headerName: t('values'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },
        {
            field: `totalWeight`,
            headerName: t('weight'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 100,
            valueGetter: ({ value, row }) => {

                // let items = row.items

                // let totalPackQty = items.reduce((total, item) => {

                //     let packQty = parseFloat(item[itemInjectionProps.packQty.retrieveKey]).toFixed(0)

                //     if (Number.isNaN(packQty) || packQty === "NaN") packQty = 0

                //     total += parseFloat(packQty)

                //     return total
                // }, 0)

                // if (Number.isNaN(totalPackQty)) totalPackQty = 0

                return value
            }
        },
        {
            field: `ax_createdatetime`,
            headerName: t('createDateTime'),
            headerAlign: 'right',
            align: 'right',
            // headerClassName: 'my-super-theme--naming-group',
            width: 200,
            valueGetter: ({ value, row }) => {
                return `${value}`
            }
        }
    ];
}